import { useEffect, useState } from 'react'
import moment from 'moment'
import Select from 'react-select'
import Box from '../../../../Global/Box'

const optionsDefaultDates = [
  {
    value: 'currentDay',
    label: 'Dia actual',
  },
  {
    value: 'currentWeek',
    label: 'Semana actual',
  },
  {
    value: 'currentMonth',
    label: 'Mes actual',
  },
  {
    value: 'currentYear',
    label: 'Año actual',
  },
]

const stylesSelect = {
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  menu: (provided) => ({ ...provided, zIndex: 9999 }),
}

const Filters = ({ filters, setFilters }) => {
  //STATES:
  const [isFiltered, setIsFiltered] = useState(false)
  const [dateFrom, setDateFrom] = useState('')
  const [dateTo, setDateTo] = useState('')
  const [selectedDefaultDate, setSelectedDefaultDate] = useState('')

  const getDateRange = (option) => {
    const optMoment = {
      currentDay: 'day',
      currentWeek: 'week',
      currentMonth: 'month',
      currentYear: 'year',
    }

    const today = moment().format('YYYY-MM-DD')

    const start = moment(today).startOf(optMoment[option])
    const end = moment(today).endOf(optMoment[option])

    return {
      start: moment(start).format('YYYY-MM-DD'),
      end: moment(end).format('YYYY-MM-DD'),
    }
  }

  const handleChangeSelectedDefaultDate = (selected) => {
    let startDate = ''
    let endDate = ''

    if (selected) {
      const calcDateRange = getDateRange(selected.value)
      startDate = calcDateRange.start
      endDate = calcDateRange.end
    }

    setDateFrom(startDate)
    setDateTo(endDate)
    setFilters((old) => ({
      ...old,
      dateFrom: startDate !== '' ? startDate : null,
      dateTo: endDate !== '' ? endDate : null,
    }))
    return setSelectedDefaultDate(selected?.value ? selected : null)
  }

  const handleChangeFilterDateRange = ({ dateValue, type }) => {
    const nameProp = type === 'from' ? 'dateFrom' : 'dateTo'
    const value = dateValue ? dateValue : null
    setFilters((old) => ({
      ...old,
      [nameProp]: value,
    }))
    if (nameProp === 'dateFrom') setDateFrom(value ?? '')
    else if (nameProp === 'dateTo') setDateTo(value ?? '')
    setSelectedDefaultDate('')
  }

  const handleCleanFilters = () => {
    setSelectedDefaultDate('')
    setDateFrom('')
    setDateTo('')

    return setFilters((old) => ({
      ...old,
      dateFrom: null,
      dateTo: null,
    }))
  }

  useEffect(() => {
    if (filters) {
      const { dateFrom, dateTo } = filters

      if (dateFrom && !dateTo) return setIsFiltered(true)
      if (dateFrom && dateTo) return setIsFiltered(true)
      setIsFiltered(false)
    }
  }, [filters])

  return (
    <Box
      classNameHeader="card-header py-1 bg-gray"
      contentHeader={
        <h3 className="card-title pl-3 mt-0">
          <div className="text-white">
            <i className="fas fa-filter pr-2" style={{ fontSize: 12 }} />
            Filtros
          </div>
        </h3>
      }
      classCardBody="card-body m-0 p-3"
      content={
        <>
          <div className="row col-12 d-flex flex-wrap mb-3 gap-4">
            <div className="pl-0 mr-3 mb-3">
              <Label
                id="typesDate"
                text="Fechas predeterminadas"
                icon={false}
              />
              <Select
                id="typesDate"
                name="typesDate"
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={stylesSelect}
                placeholder={'Selecciona una'}
                noOptionsMessage={() => 'No hay opciones'}
                options={optionsDefaultDates}
                onChange={(selected) =>
                  handleChangeSelectedDefaultDate(selected ?? null)
                }
                value={selectedDefaultDate}
                isClearable={true}
              />
            </div>

            <div className="mr-3 mb-3">
              <Label id="dateFrom" text={'Fecha inicio'} />
              <input
                id="dateFrom"
                name="dateFrom"
                type="date"
                className="input-field form-control position-searchInput"
                onChange={(e) => {
                  handleChangeFilterDateRange({
                    dateValue: e.target.value,
                    type: 'from',
                  })
                }}
                value={dateFrom}
              />
            </div>

            <div className="mr-3 mb-3">
              <Label id="dateTo" text={'Fecha fin'} />
              <input
                id="dateTo"
                name="dateTo"
                type="date"
                className="input-field form-control position-searchInput"
                onChange={(e) =>
                  handleChangeFilterDateRange({
                    dateValue: e.target.value,
                    to: 'to',
                  })
                }
                value={dateTo}
              />
            </div>
          </div>
          {isFiltered && (
            <div className="float-right">
              <button
                className="btn btn-sm btn-purple"
                onClick={() => handleCleanFilters()}
              >
                Limpiar filtros
              </button>
            </div>
          )}
        </>
      }
    />
  )
}

const Label = ({ id, text, icon = true }) => {
  return (
    <span htmlFor={id} style={{ fontSize: 14 }}>
      <b>
        {icon && (
          <i className="far fa-calendar-alt mr-1" style={{ fontSize: 11 }} />
        )}
        {text}
      </b>
    </span>
  )
}

export default Filters
